module.exports = __webpack_public_path__ + "img/start_1.91f421c3.svg";